<template>
    <v-btn
        text
        :disabled="disabled"
        class="nav-link pa-0"
        :to="to"
        exact-active-class="nav-link-active"
        exact>
		<v-icon v-if="icon">{{icon}}</v-icon>
        &nbsp;{{ title }}
    </v-btn>
</template>

<script>
export default {
	name: 'NavItem',
	props: {
		to: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
		active: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'false',
		},
	},
	computed: {
		currentRouteName() {
			return this.$route.name === this.to.name;
		},
	},
};
</script>

<style lang="scss" scoped>

.nav-link {
	color:#fff!important;
}
.nav-link:hover,
.nav-link-active {
    color: #e4af0c !important;
}
</style>
